

















































































































































































































import { Component, Vue } from 'vue-property-decorator';
import AppButton from '@/components/AppButton.vue';
import ProfileConnector from '@/connector/Profile.vue';
import AuthConnector from '@/connector/Auth.vue';
import DialogConnector from '@/connector/Dialog.vue';

@Component({
  name: 'AppNavigator',
  components: {
    AppButton,
    AuthConnector,
    ProfileConnector,
    DialogConnector,
  },
})
export default class AppNavigator extends Vue {}
